import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Assessment } from "@mui/icons-material";
import theme from "../../theme";

interface Props {}

const ReportTile: React.FC<Props> = (props) => {
  const md = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      sx={{ width: "100%", height: "100%" }}
      justifyContent="center"
    >
      <Typography fontSize={md ? "130px" : "70px"} color="#fff">
        <Assessment fontSize="inherit" />
      </Typography>
    </Box>
  );
};

export default ReportTile;
